'use strict';

(function() {
    angular
        .module('paymentRates')
        .component('paymentRatesComponent', {
            templateUrl: 'payment-rates/components/payment-rates-component.html',
            controller: function(CommonMasterData, crewProfileDTOFactory, CrewingSelectionHelper,
                AuthService, $scope, $http, EventManagerService, MessageService, $timeout, PopupManager) {
                var vm = this;

                EventManagerService.registerEventListener(EventManagerService.EVENT.PAYMENT_RATES.DELETE_RANGE, onDeleteRangeListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.PAYMENT_RATES.SAVE_RANGE, onSaveRangeListener);
                EventManagerService.registerEventListener(EventManagerService.EVENT.PAYMENT_RATES.APPLY_RANGE, onApplyRangeListener);

                vm.units = [	{Unit:'/session',Value:'/session'},
                            	{ Unit:'/per fight', Value:'/per fight' },
                            	{ Unit:'/per hour', Value:'/per hour' },
                            	{ Unit:'/per year', Value:'/per year' },
                              { Unit:'/per month', Value:'/per month' },
                              { Unit:'/per day', Value:'/per day' }
                           ];

                vm.selectedUnitSession = vm.units[0];
                vm.selectedUnitFlight = vm.units[1];
                vm.selectedUnitHour = vm.units[2];
                vm.selectedUnitYear = vm.units[3];
                vm.selectedUnitMonth = vm.units[4];
                vm.selectedUnitDay = vm.units[5];

                vm.openAddRangePopUp = function(index) {

                    var details = {
                        'rangeTitle': '',
                        'fromHour': '',
                        'toHour': '',
                        'range': 0,
                        'rowIndex': undefined,
                        'showDeleteButton': false,
                        'paymentHourRangeId': null,
                        'version': null,
                        'crewTypeCode': vm.crewType
                    };

                    if (index || index == 0) {
                        details.rangeTitle = vm.flyingRangeDetails[index].rangeTitle;
                        details.fromHour = vm.flyingRangeDetails[index].fromHour;
                        details.toHour = vm.flyingRangeDetails[index].toHour;
                        details.range = vm.flyingRangeDetails[index].range;

                        details.rowIndex = index;
                        details.showDeleteButton = true;

                        details.paymentHourRangeId = vm.flyingRangeDetails[index].paymentHourRangeId;
                        details.version = vm.flyingRangeDetails[index].version;
                    }

                    PopupManager.openModal('ADD_FLYING_HOURS_RANGE', details, function() {});
                }

                function onDeleteRangeListener(params) {
                    vm.deleteFlyingHoursDetail({
                        'param': params
                    });
                }

                function onCancelRangeListener() {
                    vm.onCloseClick();
                }

                function onApplyRangeListener(params) {

                	var isValidRangeName = true;
                	angular.forEach(vm.flyingRangeDetails, function(data, index) {
                		if (data.rangeTitle == params.rangeTitle && params.rowIndex != index) {
                			isValidRangeName = false;
                		}
                	});

                	var isValidRangeHours = true;

                	if(!!params.toHour && params.toHour < params.fromHour)
                		isValidRangeHours = false;

                	if (isValidRangeName) {
                		if(isValidRangeHours){
                			vm.saveFlyingHoursDetails({
                				'param': params
                			});
                		}
                		else{
                			MessageService.warning(MessageService.MESSAGES.PAYMENT_RATES.INVALID_RANGE_HOUR);
                		}
                	} else {
                		MessageService.warning(MessageService.MESSAGES.PAYMENT_RATES.RANGE_NAME_EXISTS);
                	}
                }

                vm.onCloseClick = function() {
                    PopupManager.closeModal('ADD_FLYING_HOURS_RANGE');
                };


                vm.addLayoverRange = function() {
                    var layOverDetails = {
                        'layoverRateRange': 0,
                        'layoverRateRangeUnit': '',
                    };
                    vm.otherPaymentDetails.layOverDetails.push(layOverDetails);
                }

                vm.deleteLayoverRange = function(index) {
                    vm.otherPaymentDetails.layOverDetails.splice(index, 1);
                }

                function onSaveRangeListener() {
                    vm.saveOtherPaymentRates({
                        'param': vm.otherPaymentDetails
                    });
                }

            },
            controllerAs: 'paymentRatesComponent',
            bindings: {
                flyingRangeDetails : '=',
                otherPaymentDetails : '=',
                crewType: '=',
                showOtherPaymentDetails: '=',
                showFlyingHourDetails: '=',
                saveOtherPaymentRates: '&',
                saveFlyingHoursDetails: '&',
                deleteFlyingHoursDetail: '&'
            }
        });
})();
